module.exports = __webpack_public_path__ + "media/images/icons/outlined/dropbox-7a484d31fc9d18ae521940afa01a71bb.svg";